import { useState, useEffect } from 'react';
import { Box, Fab } from '@mui/material';
import { styles } from './styles';
import icon_mini_chat_active from '@images/icon_mini_chat_active.png';
import icon_mini_chat_inactive from '@images/icon_mini_chat_inactive.png';
import i18n from 'i18next';
import bookingStore from '@store/booking.store';
import { getCountryCodeList, getLanguageCodeList } from '@apis';
import { gtmCloseAssistant, gtmOpenAssistant } from '@gtm';
import useConfigStore from '@constants/hooks/useConfigStore';
import MiniChatRoomSingle from '@components/MiniChatRoomSingle';

export default function MiniChatRoot(props) {
  const { style, language, country, channelType, channelLink } = props;
  const { fetchConfigSettings, isConfigLoaded, FIREBASE_API_KEY, DECRYPT_FIRST_KEY, DECRYPT_SECOND_KEY } = useConfigStore();

  //dev 배포시 true으로 전환
  // const [miniChatOpened, setMiniChatOpened] = useState(true);

  //staging
  const [miniChatOpened, setMiniChatOpened] = useState(false);

  //
  const { setSelectedCountry, setSelectedLanguage } = bookingStore();

  useEffect(() => {
    if (language) {
      const newLanguage = `${language}`;
      const supportedLanguages = ['en', 'it', 'no', 'sk', 'nl', 'cs', 'pl', 'fr', 'es'];
      if (i18n && Array.isArray(supportedLanguages) && supportedLanguages.includes(newLanguage)) {
        i18n.changeLanguage(newLanguage);
      } else {
        i18n.changeLanguage('en');
      }
    } else {
      const fetchData = async () => {
        const url = window.location.pathname;
        const [pre1, countryPrefix, languagePrefix, pre2, pre4] = url.split('/');

        const languageResponse = await getLanguageCodeList();
        if (languageResponse) {
          const { data: languageList } = languageResponse;
          const selectedLanguage = languageList.find((language) => language.languageCode.toLowerCase() === languagePrefix) || 'en';
          if (selectedLanguage) {
            setSelectedLanguage(selectedLanguage);
            i18n.changeLanguage(selectedLanguage.languageCode);
          }
        }
      };
      fetchData();
    }
  }, [language]);

  //--------------------------------------------------------------------------------------------------------------------------

  useEffect(() => {
    if (country) {
      setSelectedCountry({ country: country.toUpperCase(), countryCode: country });
      setSelectedLanguage({ languageCode: language });
    } else {
      const fetchData = async () => {
        const url = window.location.pathname;
        const [pre1, countryPrefix, languagePrefix, pre2, pre4] = url.split('/');

        const countryResponse = await getCountryCodeList();
        if (countryResponse) {
          const { data: countryList } = countryResponse;
          let selectedCountry =
            countryList.find((country) => country.countryCode.toLowerCase() === countryPrefix) ||
            countryList.find((country) => country.countryCode.toLowerCase() === languagePrefix) ||
            countryList.find((country) => country.countryCode.toLowerCase());
          if (selectedCountry) {
            setSelectedCountry(selectedCountry);
          }
        }
      };
      fetchData();
    }
  }, [country]);

  // -------------------------------------------------------------
  const handleClick = async () => {
    if (miniChatOpened) {
      gtmCloseAssistant();
      setMiniChatOpened(false);
    } else {
      gtmOpenAssistant();
      if (!isConfigLoaded) {
        await fetchConfigSettings();
      }
      setMiniChatOpened(true);
    }
  };

  return (
    <Box
      sx={[
        styles.miniChatContainer,
        style,
        {
          height: miniChatOpened ? `calc(100vh - ${style.bottom} - 40px)` : 'auto',
        },
      ]}
    >
      <Fab disableRipple onClick={handleClick} sx={styles.miniChatButton}>
        {miniChatOpened ? (
          <img style={styles.miniChatIcon} src={icon_mini_chat_active} alt="icon_mini_chat_active" />
        ) : (
          <>
            <img style={styles.miniChatIcon} src={icon_mini_chat_inactive} alt="icon_mini_chat_inactive" />
            {/* badge UI */}
            {/* {badge ? (
              <Badge color="error" sx={styles.unreadIcon}>
                <Typography sx={styles.unreadText}>{badge}</Typography>
              </Badge>
            ) : null} */}
          </>
        )}
      </Fab>

      {miniChatOpened && FIREBASE_API_KEY && DECRYPT_FIRST_KEY && DECRYPT_SECOND_KEY && (
        <MiniChatRoomSingle setMiniChatOpened={setMiniChatOpened} channelType={channelType} channelLink={channelLink} />
      )}
    </Box>
  );
}
